import { tenantSettings } from './tenantSettings'
import { derived } from 'svelte/store'

export const tenantId = derived(
	tenantSettings,
	($tenantSettings) => $tenantSettings.tenantDetail.id,
)
